import axios, { AxiosRequestConfig, Method } from 'axios';
import { BASE_URL } from '../apis';

interface ApiOptions {
  endpoint: string;
  method?: Method;
  body?: any;
  token?: string;
  formData?: FormData;
}

const createAxiosConfig = (options: ApiOptions): AxiosRequestConfig => {
  const { endpoint, method = 'GET', body, token, formData } = options;

  const isMultipart = !!formData;

  const config: AxiosRequestConfig = {
    url: `${BASE_URL}${endpoint}`,
    method,
    headers: {
      ...(isMultipart ? {} : { 'Content-Type': 'application/json' }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    timeout: 30000,
  };

  if (isMultipart) {
    config.data = formData;
  } else if (body && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
    config.data = body;
  }

  return config;
};

export const hitApi = async (options: ApiOptions): Promise<any> => {
  try {
    const config = createAxiosConfig(options);
    const response = await axios(config);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw {
        status: error.response.status,
        data: error.response.data,
        message:
          error.response.data?.message ||
          error.response.data?.error ||
          'Server error occurred',
      };
    } else if (error.request) {
      throw {
        status: 0,
        message: 'No response from server. Please check your connection.',
      };
    } else {
      throw {
        status: -1,
        message: error.message || 'An unexpected error occurred',
      };
    }
  }
};

export const hitApi2 = hitApi;
